import React from "react";

const pricingData = [
  {
    title: "Personal Branding",
   
    monthly: "$10 - Monthly",
    annual: "$100 - Annual Cost(2 Months Free)",
    colo:'#2e3192'
  },
  {
    title: "Business Branding",
    
    monthly: "$10 - Monthly",
    annual: "$100 - Annual Cost(2 Months Free)",
  },
  {
    title: "Agency",
    
    monthly: "$100 - Monthly",
    annual: "$1000 - Annual Cost(2 Months Free)",
  },
];

const PricingPlans = () => {
  return (
    <div className="elementor-widget-container">
      <div className="container">
        <div className="row">
          <div className="col-lg-8 offset-lg-2">
            <div className="site-heading text-center">
              <h2>Pricing Plan</h2>
            </div>
          </div>
        </div>

        <div className="row">
          {pricingData.map((plan, index) => (
            <div className="col-sm-12 col-lg-4 col-xl-4 col-md-4" key={index}>
              <div className="item-knackhire">
                <div className="info">
                  <h4 className="pricing-headings">{plan.title}</h4>
                  <p>{plan.features}</p>
                  <hr />
                  <p>{plan.monthly}</p>
                  <hr />
                  <p>{plan.annual}</p>
                  {/* 👉 Conditionally show extra line for Agency */}
                  {plan.title === "Agency" && (
                    <p className="text-gray-600 mt-3">
                      This subscription can manage 20 users
                    </p>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
      <style jsx>{`
.item-knackhire {
    padding: 60px 30px;
    padding-top: 30px;
    position: relative;
    z-index: 1;
    border-radius: 5px;
    box-shadow: 0 0 10px #cccccc;
    height: 320px;
   
    
}
 
`}</style>
    </div>
  );
};

export default PricingPlans;
